
export enum ClaimTypeCd {
	DAMAGE = 'Damage',
	SHORTAGE = 'Shortage'}

